<div class="top">
    <div class="heading">
        <span class="fw-bold" style="font-size: 18px; text-transform: uppercase;"> {{'Update Taxpayer profile'}}</span>
    </div>
    <i class="material-icons text-danger" role="button" (click)="closeModal()">
        close
    </i>
</div>


<div class="form-wrapper">
    <div class="image-container">
        <img [src]="this.details?.photo || '/assets/img/user-placeholder.png'" alt="">
    </div>

    <div class="content">
        <div class="details">
            <div class="d-flex gap-4 justify-content-between flex-column flex-xl-row mb-4">
                <div class="left d-flex flex-column gap-2">
                    <span class="fw-bold"
                        style="font-size: 18px; text-transform: uppercase;">{{this.dialogData?.displayName ||
                        'TAXPAYER'}}</span>
                    <div><strong class="fw-bold">ASIN: </strong> {{ this.details?.tin }}</div>
                    <div><strong class="fw-bold">Phone: </strong> {{ this.details?.phoneNumber }}</div>
                    <div><strong class="fw-bold">Email: </strong> {{ this.details?.email }}</div>
                    <div><strong class="fw-bold">Address: </strong> {{ this.details?.address }}</div>
                </div>

                <div class="d-flex flex-column gap-2 align-items-start align-items-xl-end">
                    <div class="d-flex align-items-center gap-1">
                        <span class="font-size-small text-nowrap">Taxpayer Type:</span>
                        <span
                            style="background-color: #F2EACF; color: #686988; padding: 3px 15px; border-radius: 999px; font-size: 13px;">
                            {{this.details?.taxGroup}}</span>
                    </div>
                    <div class="d-flex align-items-start justify-content-xl-end flex-wrap gap-1">
                        <p style="font-size: 13px; color: #6B6C7E; margin: 0;">Date of Registration:</p>
                        <small class="fw-bold" style="font-size: 13px; margin: 0;">{{ this.details?.dateCreated }}</small>
                    </div>

                    <button class="gold-btn mt-auto" style="font-size: 13px; gap: 10px;" (click)="downloadCertificate()">
                        {{isDownloadingCertificate ? 'Downloading Certificate' : 'Download Certificate'}}


                        <svg *ngIf="!isDownloadingCertificate" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M11.8104 8.51172V10.6492C11.8104 10.9327 11.6978 11.2045 11.4973 11.4049C11.2969 11.6054 11.0251 11.718 10.7416 11.718H3.2604C2.97695 11.718 2.70511 11.6054 2.50468 11.4049C2.30425 11.2045 2.19165 10.9327 2.19165 10.6492V8.51172"
                                stroke="white" stroke-width="1.06875" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M4.3291 5.83984L7.00097 8.51171L9.67283 5.83984" stroke="white"
                                stroke-width="1.06875" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M7.00098 8.5116V2.09912" stroke="white" stroke-width="1.06875"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                        <div class="spinner-light" *ngIf="isDownloadingCertificate">

                        </div>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>